import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative pt-32 pb-20 bg-gradient-to-br from-gray-50 to-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          {/* Left Content */}
          <div className="lg:col-span-7">
            <div className="inline-block mb-6">
              <span className="text-[#06B6D4] text-sm font-semibold uppercase tracking-wider">
                Creative Solutions That Convert
              </span>
            </div>
            
            <h1 className="text-5xl lg:text-7xl font-bold text-gray-900 leading-tight mb-6">
              Transform Your Brand Into A{' '}
              <span className="italic text-[#06B6D4]">Visual</span> Powerhouse
            </h1>
            
            <p className="text-xl text-gray-600 mb-8 max-w-2xl leading-relaxed">
              We help small businesses, churches, and entrepreneurs stand out with strategic design, impactful signage, and print solutions that drive real results.
            </p>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 mb-12">
              <Link
                to="/contact"
                className="inline-flex items-center justify-center bg-gray-900 text-white px-8 py-4 rounded-lg text-base font-semibold hover:bg-gray-800 transition-all duration-200 hover:shadow-xl whitespace-nowrap group"
              >
                Book Free Consultation
                <i className="ri-arrow-right-line ml-2 group-hover:translate-x-1 transition-transform"></i>
              </Link>
              <Link
                to="/portfolio"
                className="inline-flex items-center justify-center border-2 border-gray-900 text-gray-900 px-8 py-4 rounded-lg text-base font-semibold hover:bg-gray-900 hover:text-white transition-all duration-200 whitespace-nowrap"
              >
                View Our Work
              </Link>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-6 max-w-2xl">
              <div className="flex items-start space-x-3">
                <div className="w-10 h-10 bg-[#06B6D4]/10 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-checkbox-circle-fill text-[#06B6D4] text-xl"></i>
                </div>
                <div>
                  <p className="text-2xl font-bold text-gray-900">750+</p>
                  <p className="text-sm text-gray-600">Projects Delivered</p>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <div className="w-10 h-10 bg-[#06B6D4]/10 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-star-fill text-[#06B6D4] text-xl"></i>
                </div>
                <div>
                  <p className="text-2xl font-bold text-gray-900">96%</p>
                  <p className="text-sm text-gray-600">Client Satisfaction</p>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <div className="w-10 h-10 bg-[#06B6D4]/10 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-award-fill text-[#06B6D4] text-xl"></i>
                </div>
                <div>
                  <p className="text-2xl font-bold text-gray-900">15+</p>
                  <p className="text-sm text-gray-600">Years Experience</p>
                </div>
              </div>
            </div>
          </div>

          {/* Right Visual */}
          <div className="lg:col-span-5">
            <div className="relative">
              <div className="rounded-3xl overflow-hidden shadow-2xl border-4 border-white">
                <div className="w-full h-[500px]">
                  <img
                    src="https://public.readdy.ai/ai/img_res/350348ae86ad071482b55e65c01e79d7.jpg"
                    alt="Sign Equipment"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </section>
  );
}